import { render } from "./Activites.vue?vue&type=template&id=24217bae"
import script from "./Activites.vue?vue&type=script&lang=js"
export * from "./Activites.vue?vue&type=script&lang=js"

import "./Activites.vue?vue&type=style&index=0&id=24217bae&lang=less"
script.render = render

export default script